import { InjectionToken } from '@angular/core';
import { FilterGroup, MainMenuItem } from '@nx-icilalune/data/icilalune/types';
import { Observable } from 'rxjs';

export const PROJECT_DETAIL_FILTERS = new InjectionToken<FilterGroup[]>(
  'PROJECT_DETAIL_FILTERS'
);

export const DETAIL_FEATURE_CURRENT_MENU_ITEM =
  new InjectionToken<MainMenuItem>('DETAIL_FEATURE_CURRENT_MENU_ITEM');

export const DETAIL_FEATURE_CURRENT_MENU_TREE_ITEM =
  new InjectionToken<MainMenuItem>('DETAIL_FEATURE_CURRENT_MENU_ITEM');

export const MADE_IN_LUNE_MENU_ITEM = new InjectionToken<
  MainMenuItem | undefined
>('MADE_IN_LUNE_MENU_ITEM');

export const DETAIL_BREADCRUMBS = new InjectionToken<
  Observable<MainMenuItem[]>
>('DETAIL_BREADCRUMBS');

export const DETAIL_FEATURE_CURRENT_MENU_TREE_ITEM_PARENT =
  new InjectionToken<MainMenuItem>(
    'DETAIL_FEATURE_CURRENT_MENU_TREE_ITEM_PARENT'
  );
